module.exports = __webpack_public_path__ + "img/甘肃文旅_03.14cc7009.jpg";